/**
 * Tour Component
 */
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import Tour from 'reactour';
import {compose} from 'redux';
import {changeUserTourStep, stopUserTour} from '../../actions';
import {userTourStepCongratulations, userTourStepWaitForRecognition} from '../../constants';
import './TourStyles.css';

const TourComponent = ({runUserTour, currentTourStep, stopUserTour, changeUserTourStep}) => {
    const {t: translate} = useTranslation();

    const steps = [
        {
            selector: '[data-user-tour="step-choose-doc-type"]',
            content: <div className="default-content-div">{translate('user_tour.steps.choose_doc_type')}</div>,
            action: (node) => {
                if (!node) {
                    stopUserTour();
                }
            },
        },
        {
            selector: '[data-user-tour="open-document-uploading"]',
            content: <div className="default-content-div">{translate('user_tour.steps.open_document_uploading')}</div>,
        },
        {
            selector: '[data-user-tour="upload-document"]',
            content: <div className="default-content-div">{translate('user_tour.steps.upload_document')}</div>,
            action: (node) => {
                // If upload documents popover isn`t open change step to previous one
                if (!node) {
                    changeUserTourStep(currentTourStep - 1);
                }
            },
        },
        {
            selector: '[data-user-tour="wait-for-recognition"]',
            content: <div className="default-content-div">{translate('user_tour.steps.wait_for_recognition')}</div>,
        },
        {
            selector: '[data-user-tour="go-to-edit"]',
            content: <div className="default-content-div">{translate('user_tour.steps.go_to_edit')}</div>,
        },
        {
            selector: '[data-user-tour="step-start-tour-again"]',
            content: <div className="default-content-div">{translate('user_tour.steps.congratulations')}</div>,
        },
    ];

    return (
        <Tour
            steps={steps}
            isOpen={runUserTour}
            onRequestClose={stopUserTour}
            disableKeyboardNavigation={true}
            disableDotsNavigation={true}
            showButtons={currentTourStep === userTourStepWaitForRecognition}
            showNavigation={false}
            rounded={10}
            disableFocusLock={true}
            goToStep={currentTourStep}
            startAt={0}
            nextStep={() => changeUserTourStep(currentTourStep + 1)}
            prevStep={() => changeUserTourStep(currentTourStep - 1)}
            badgeContent={(curr, tot) => `${curr}/${tot}`}
            closeWithMask={currentTourStep === userTourStepCongratulations}
        />
    );
};

// map state to props
const mapStateToProps = ({settings}) => {
    return {...settings.userTour};
};

export default compose(
    connect(mapStateToProps, {stopUserTour, changeUserTourStep}),
)(TourComponent);
